/* eslint-disable no-magic-numbers */
import { FontName } from '@/components/Map/MapViewer/MapViewer.types';
import { getFontName } from '@/components/Map/MapViewer/utils/mapElementsRendering/text/getFontName';

export default function getWrappedTextWithFontSize({
  text,
  maxWidth,
  maxHeight,
  fontNameEnum,
  minFontSize = 3,
  maxFontSize = 16,
}: {
  text: string;
  maxWidth: number;
  maxHeight: number;
  fontNameEnum: FontName;
  minFontSize?: number;
  maxFontSize?: number;
}): { text: string; fontSize: number } {
  const result = {
    text,
    fontSize: maxFontSize,
  };
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (!context) {
    return result;
  }

  let resultFontSize = maxFontSize;
  let resultText = text;
  const fontName = getFontName(fontNameEnum);
  for (let testFontSize = maxFontSize; testFontSize >= minFontSize; testFontSize -= 1) {
    context.font = `${testFontSize}pt ${fontName}`;
    let currentLine = '';
    let splittedText = '';
    resultFontSize = testFontSize;
    text.split(' ').forEach((word: string) => {
      const testLine = currentLine ? `${currentLine} ${word}` : word;
      const testWidth = context.measureText(testLine).width;

      if (testWidth > maxWidth && currentLine) {
        splittedText += `\n${currentLine}`;
        currentLine = word;
      } else {
        currentLine = testLine;
      }
    });
    if (currentLine) {
      splittedText += `\n${currentLine}`;
    }
    const lines = splittedText.split('\n');
    const maxLineWidth = lines.reduce(
      (maxFoundWidth, line) => Math.max(maxFoundWidth, context.measureText(line).width),
      0,
    );
    if (maxLineWidth <= maxWidth && testFontSize * lines.length <= maxHeight) {
      resultText = splittedText;
      break;
    }
  }
  result.text = resultText;
  result.fontSize = resultFontSize;
  return result;
}
